import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-popup-container-component',
  templateUrl: './popup-container-component.component.html',
  styleUrls: ['./popup-container-component.component.scss']
})
export class PopupContainerComponentComponent {
  popupOverlay: boolean = true;
  @Input() width: string = ''

  @Output() closePopupDrawer = new EventEmitter<void>()


  closePopup() {
    this.closePopupDrawer.emit()
  }
}
